<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="toc">
<p class="ctfm"><a class="page" id="pvii"></a><a class="page" id="pvi"></a>CONTENTS</p>
<p class="tocfm"><a class="xref" href="#/chistewart0007#preface"><i>PREFACE</i> Returns of Theory</a></p>
<p class="tocfm"><a class="xref" href="#/chistewart0008#intro"><i>INTRODUCTION</i> Narrative Spycams—A Foreshortened View</a></p>
<p class="toc"><a class="xref" href="#/chistewart0009#ch01"><i>1</i> The Prying “I” of Montage</a></p>
<p class="toc"><a class="xref" href="#/chistewart0010#ch02"><i>2</i> Telescreen Prose</a></p>
<p class="toc"><a class="xref" href="#/chistewart0011#ch03"><i>3</i> Feedback Loops of the Technopticon</a></p>
<p class="toc"><a class="xref" href="#/chistewart0012#ch04"><i>4</i> In Plane Sight</a></p>
<p class="toc"><a class="xref" href="#/chistewart0013#ch05"><i>5</i> The Othering of Lives</a></p>
<p class="toc"><a class="xref" href="#/chistewart0014#ch06"><i>6</i> Digital Reconnaissance and Wired War</a></p>
<p class="toc"><a class="xref" href="#/chistewart0015#ch07"><i>7</i> Retrospecular Eyes</a></p>
<p class="toc"><a class="xref" href="#/chistewart0016#ch08"><i>8</i> Parallel World Editing</a></p>
<p class="tocbm"><a class="xref" href="#/chistewart0017#postface"><i>POSTFACE</i> On Mediation as Interface</a></p>
<p class="tocbm"><a class="xref" href="#/chistewart0018#notes"><i>NOTES</i></a></p>
<p class="tocbm"><a class="xref" href="#/chistewart0019#index"><i>INDEX</i></a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-stewart-0005.vue?4afe8d50